import { useEffect } from 'react';

import { useAuthContext } from 'utils/auth';

function Logout() {
  const { logout } = useAuthContext();

  useEffect(() => {
    // FIXME: Remove debug after logout problem is solved
    console.debug('Logout: logging out by calling logout.');
    logout({ broadcast: true });
  }, [logout]);

  return null;
}

export default Logout;
